<template>
  <el-card class="my-box-card">
    <div>
      <el-input size="small" placeholder="输入订单编号/关键字" clearable style="width: 220px;float: left"
                v-model="formParam.keyWord"></el-input>
      <el-date-picker size="small" style="margin-left: 20px;float: left;width: 140px;"
                      v-model="formParam.stime"
                      type="date"
                      placeholder="交易日期起">
      </el-date-picker>
      <span style="margin-left: 10px;float: left"></span>
      <el-date-picker size="small" style="margin-left: 10px;float: left;width: 140px;"
                      v-model="formParam.etime"
                      type="date"
                      placeholder="交易日期止">
      </el-date-picker>
      <el-button size="small" type="info" plain style="margin-left: 10px;float: left" @click="handleSearch">搜索
      </el-button>
    </div>
    <el-table
      v-loading="loadingTable"
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="orderNo"
        label="订单编号"
        width="200">
      </el-table-column>
      <el-table-column
        prop="orderType"
        label="交易类型"
        width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.orderType === '1'">会员充值</span>
          <span v-if="scope.row.orderType === '2'">委托单支付</span>
          <span v-if="scope.row.orderType === '3'">商品购买</span>
          <span v-if="scope.row.orderType === '4'">查看资源</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="orderDesc"
        show-overflow-tooltip
        label="交易内容">
        <template slot-scope="scope">
          <span v-if="scope.row.payType === '0'">微信支付</span>
          <span v-if="scope.row.payType === '1'">支付宝支付</span>
          <span v-if="scope.row.payType === '2'">转账支付</span>
          <el-divider direction="vertical"></el-divider>
          <span>{{scope.row.orderDesc}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="payFee"
        label="交易金额(元)"
        width="120">
        <template slot-scope="scope">
          {{scope.row.payFee | convertMoney}}
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="支付状态"
        width="80">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === '0'" type="success">支付成功</el-tag>
          <el-tag v-if="scope.row.status === '1'" type="danger">支付失败</el-tag>
          <el-tag v-if="scope.row.status === '2'" type="warning">审核中</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="hasInvoice"
        label="开票状态"
        width="80">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.hasInvoice === '0'" type="danger">未开票</el-tag>
          <el-tag v-if="scope.row.hasInvoice === '1'" type="success">已开票</el-tag>
          <el-tag v-if="scope.row.hasInvoice === '2'" type="warning">不开票</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="updateTime"
        width="100"
        label="交易日期">
        <template slot-scope="scope">
          {{scope.row.updateTime | dateToStr}}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="60">
        <template slot-scope="scope">
          <el-button type="text" @click="handleView(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-bind:child-msg="pageParam" @callFather="callFather"></pagination>
    <el-dialog title="账单查看" center
               :visible.sync="dialogView"
               width="30%" append-to-body>
      <el-row>
        <el-col :span="24">
          订单编号：{{currBill.orderNo}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          交易类型：
          <span v-if="currBill.orderType === '1'">会员充值</span>
          <span v-if="currBill.orderType === '2'">委托单支付</span>
          <span v-if="currBill.orderType === '3'">商品购买</span>
          <span v-if="currBill.orderType === '4'">查看资源</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          交易内容：{{currBill.orderDesc}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          交易金额：{{currBill.payFee | convertMoney}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          交易日期：{{currBill.updateTime | dateToStr}}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          支付类型：
          <span v-if="currBill.payType === '0'">微信支付</span>
          <span v-if="currBill.payType === '1'">支付宝支付</span>
          <span v-if="currBill.payType === '2'">转账支付</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          支付状态：
          <span v-if="currBill.status === '0'" type="success">支付成功</span>
          <span v-if="currBill.status === '1'" type="danger">支付失败</span>
          <span v-if="currBill.status === '2'" type="warning">审核中</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          开票状态：
          <span v-if="currBill.hasInvoice === '0'" type="danger">未开票</span>
          <span v-if="currBill.hasInvoice === '1'" type="success">已开票</span>
          <span v-if="currBill.hasInvoice === '2'" type="warning">不开票</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          支付凭证：
          <el-image
            v-if="currBill.sign === '1'"
            style="width: 120px; height: 120px;vertical-align: middle;"
            :src="currBill.payCred"
            :preview-src-list="[currBill.payCred]">
          </el-image>
          <div v-if="currBill.sign === '0'">无上传凭证</div>
          <a v-if="currBill.sign === '2'" :href="currBill.payCred">{{currBill.fileName}}</a>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogView = false">返回</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import { list } from '@/api/user/pay'

export default {
  name: 'myBill',
  data () {
    return {
      tableData: [],
      loadingTable: false,
      dialogView: false,
      searchText: '',
      currBill: {},
      pageParam: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      formParam: {
        keyWord: ''
      }
    }
  },
  created () {
    if (this.$route.params.sid) {
      this.formParam.keyWord = this.$route.params.sid
    }
    this.handleSearch()
  },
  methods: {
    handleSearch () {
      this.formParam.page = {
        pageNum: this.pageParam.currentPage,
        pageSize: this.pageParam.pageSize
      }
      this.mockTableData()
    },
    handleView (row) {
      this.currBill = row
      if (row.payCred !== '' && row.payCred !== null && row.payCred !== undefined) {
        // 获取最后一个.的位置
        var index = row.payCred.lastIndexOf('.')
        // 获取后缀
        var ext = row.payCred.substr(index + 1)
        if (ext === 'jpg' || ext === 'png' || ext === 'bmp') {
          this.currBill.sign = '1'
        } else {
          this.currBill.sign = '2'
          this.currBill.fileName = '转账凭证.' + ext
        }
        this.currBill.payCred = row.payCred
      } else {
        this.currBill.sign = '0'
      }
      this.dialogView = true
    },
    // 分页插件事件
    callFather (parm) {
      this.pageParam.currentPage = parm.currentPage
      this.pageParam.pageSize = parm.pageSize
      this.handleSearch()
    },
    mockTableData () {
      this.loadingTable = true
      list(this.formParam).then(res => {
        this.loadingTable = false
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          this.tableData = result.bizData
          this.pageParam.total = result.total
        }
      }).catch(ex => {
        this.loadingTable = false
        this.$message.error('列表加载失败，请稍后再试！')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-row {
    margin-bottom: 5px;
  &:last-child {
     margin-bottom: 0;
   }
  }
</style>
